

function personas() {
    return(
        <div>
        </div>
    )

}
export default personas;